import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { useHistory } from 'react-router-dom'
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, CardLink, Col, Container, Fade, Row } from "reactstrap";
import { DateRangePicker } from 'react-date-range';
import { messageBoardAction } from '../../actions/messageBoardAction';
import { DABBackToList, LoadingSpinnerModal } from '../../components/dab';
import moment from 'moment';
import { showAlert } from "../common/functions";

interface IReportsProps {
	dispatch: Dispatch<any>;
	messageBoardData: any;
	id: number;
	callback: any;
}

const Reports: React.SFC<IReportsProps> = ({
	dispatch, messageBoardData, id, callback }) => {

	const [fadeIn, setFadeIn] = useState(false);
	const [showClearFilter, setShowClearFilter] = useState(false);
	const [initialDate] = useState([
		{
			endDate: new Date(),
			startDate: new Date(new Date().setFullYear(new Date().getFullYear() - 2)),
			key: 'selection'
		}
	]);
	const [dateRange, setDateRange] = useState(initialDate);
	const [topPostsList, setTopPostsList] = useState([]);
	const [mostTopicsList, setMostTopicsList] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [isTitleLoaded, setIsTitleLoaded] = useState(false);

	const dateInpput=(date, months)=> {
		date.setMonth(date.getMonth() + months);
		return date;
	}

	React.useEffect(() => {
		if ((id > 0)) {
			dispatch(messageBoardAction.messageBoardGetDetail(id));
			setShowModal(true);
		}
	}, []);

	const handleToggle = () => setFadeIn(!fadeIn);

	const history = useHistory();

	const handleBackClick = (event) => {
		event.preventDefault();
		history.goBack();
	}

	const handleFilterClear = () => {
		setFadeIn(false);
		setShowClearFilter(false);
		if ((id > 0)) {
			dispatch(messageBoardAction.messageBoardGetReport(id, moment(dateInpput(new Date(), -12)).format("YYYY-MM-DD"), moment(dateInpput(new Date(), 0)).format("YYYY-MM-DD")));
			setShowModal(true);
		}
		setDateRange(initialDate);
	}

	const handleFilter = () => {
		if ((id > 0)) {
			dispatch(messageBoardAction.messageBoardGetReport(id, dateRange[0].startDate.toISOString(), dateRange[0].endDate.toISOString()));
			setShowModal(true);
		}
		setShowClearFilter(true);
	}

	if (messageBoardData && messageBoardData.isSuccess && messageBoardData.isSingleMessageLoaded) {
		if (!isTitleLoaded && messageBoardData.aMessageData) {
			if (messageBoardData.aMessageData && messageBoardData.aMessageData !== null) {
				callback(messageBoardData.aMessageData.title);
				setIsTitleLoaded(true);
				dispatch(messageBoardAction.messageBoardGetReport(id, moment(dateInpput(new Date(), -12)).format("YYYY-MM-DD"), moment(dateInpput(new Date(), 0)).format("YYYY-MM-DD")));
			}
		}
	}

	if (messageBoardData && messageBoardData.isSuccess && !messageBoardData.isError) {
		if (messageBoardData.isTopPostsLoaded) {
			if (messageBoardData.topPostsData) {
				setTopPostsList(messageBoardData.topPostsData.topPosters);
				setMostTopicsList(messageBoardData.topPostsData.topResponses);
			}
			messageBoardData.isTopPostsLoaded = false;
			setShowModal(false);
		}
	}

	if (messageBoardData && messageBoardData.isError && !messageBoardData.isSuccess) {		
		if (messageBoardData.status === 'Unauthorized') {
			history.push("/401");
		} else {
			showAlert(messageBoardData.status, true);
		}
		setShowModal(false);
		messageBoardData.isError = false;
	}

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	return (
		<div className="forum-report">
			<div className='card-box'>
				<DABBackToList data-testid="backToList" onClick={(e) => { handleBackClick(e); }} />
				<Col lg="8" className='column'>
					<CardLink onClick={handleToggle} className='card-box-link'>Filter List</CardLink>
						{showClearFilter ?
						<CardLink onClick={handleFilterClear} className='card-box-link-filter'>Clear Filter</CardLink>
							: <CardLink className='card-box-link-filter-disabled'>Clear Filter</CardLink>}
				</Col>
				{fadeIn && (
					<Fade in={fadeIn} tag="h5" className='card-fade'>
						<Container className='filter-container'>
							<div className='box-container'>
								<Row>
									<Col lg="12">
										<div className='close-div'>
											<FontAwesomeIcon data-bs-toggle="tooltip" data-bs-placement="bottom" size='3x'
												title="Close" icon={faTimes} onClick={handleToggle} />
										</div>
									</Col>
								</Row>
								<Row>
									<Col lg="11">
										<label>Date</label>
										<div >
											<DateRangePicker
												onChange={item => setDateRange([item.selection])}
												showSelectionPreview={false}
												moveRangeOnFirstSelection={false}
												months={2}
												ranges={dateRange}
												direction="horizontal"
											/>
										</div>
									</Col>
									<Col lg="1">
										<Button id="submit" className="inner-filter-link" onClick={() => { handleFilter(); }}>Filter</Button>
									</Col>
								</Row>
							</div>
						</Container>
					</Fade>)}
			</div>
			<span className='heading_3'> Top Posters </span>
			<table data-testid="topPostTable" className='table'>
				<thead>
					<tr className='trow'>
						<th scope="col" className='th' data-testid="reportUserName">Username</th>
						<th scope="col" className='th'data-testid="reportNumberofPosts">Number of Posts</th>
					</tr>
				</thead>
				<tbody data-testid="topPostTableBody">
					{
						topPostsList.length === 0 ?
							<tr className='trow' >
								<td >No Records...</td>
							</tr>
							:
							topPostsList && (topPostsList).map((data: any) =>
								<tr key={data.userId} className='trow' >
									<td id={"userName" + data.userId} className='col-width-border'>										
										<a href={"/dashboard?id=" + data.userId} className="detail-link" data-testid={"authorLink"}>{data.userName}</a>
									</td>
									<td id={"postCount" + data.userId} className='col-align' >{data.postCount}</td>
								</tr>
							)
					}
				</tbody>
			</table>

			<span className='heading_3'> Most Responded to Topics </span>
			<table data-testid="mostResTopicTable" className='table'>
				<thead>
					<tr className='trow'>
						<th scope="col" className='th'>Topic</th>
						<th scope="col" className='th'>Creator</th>
						<th scope="col" className='th'>Responses</th>
					</tr>
				</thead>
				<tbody data-testid="mostResTopicBody">
					{
						mostTopicsList.length === 0 ?
							<tr className='trow' >
								<td >No Records...</td>
							</tr>
							:
							mostTopicsList && (mostTopicsList).map((data: any) =>
								<tr key={data.topicId} className='trow'>
									<td id={"topicName" + data.topicId} className='col-width-border-6'>
										<a href={`/messageboard?page=posts&id=${data.topicId}`} className="detail-link" data-testid={"topicLink"}>{data.topicName}</a>
									</td>
									<td id={"usrName" + data.topicId} className='td'>
										<a href={"/dashboard?id=" + data.userId} className="detail-link" data-testid={"userLink"}>{data.userName}</a>
									</td>
									<td id={"postCount" + data.topicId} className='col-align'>{data.postCount}</td>
								</tr>
							)
					}
				</tbody>
			</table>
			{
				showModal && (
					<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />
				)
			}
		</div>
	);
};


const mapStateToProps = (state: any) => {
	const { messageBoardData } = state;
	return {
		messageBoardData
	};
};

export default connect(mapStateToProps)(Reports);